import { TextField, Theme } from '@mui/material';
import { alpha, styled } from '@mui/system';

export const StyledTextInput = styled(TextField)(
  ({
    theme,
    error,
    value,
  }: {
    theme: Theme;
    error: boolean;
    value: string;
  }) => ({
    paddingTop: theme.spacing(6),
    margin: 0,
    '.MuiInputLabel-root': {
      transform: `translate(${theme.spacing(4)}, ${theme.spacing(
        10.5,
      )}) scale(1)`,
      color: theme.palette.grey[300],
      marginBottom: theme.spacing(1),
    },
    '.MuiInputLabel-shrink': {
      transform: `translate(${theme.spacing(4)}, ${theme.spacing(
        0,
      )}) scale(0.75)`,
      color: theme.palette.grey[900],
    },
    '.MuiOutlinedInput-root': {
      border: 1,
      borderStyle: 'solid',
      borderColor: theme.palette.grey[400],
      '&.Mui-focused': {},
    },
    '.MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '.Mui-focused': {
      borderColor: theme.palette.primary.main,
    },
    input: {
      padding: theme.spacing(4),
      borderRadius: theme.spacing(4),
      transition: 'all 0.1s',
      backgroundColor: theme.palette.common.white,
      '&:placeholder': {
        color: theme.palette.grey[300],
      },
    },
    '.MuiFormHelperText-root': {
      color: alpha(theme.palette.common.black, 0.6),
      fontSize: theme.spacing(3),
      lineHeight: theme.spacing(4),
      marginTop: theme.spacing(1),
    },
    '&:hover': {
      label: {
        color: !error && theme.palette.grey[400],
      },
    },
    '&:focus-within': {
      label: {
        marginBottom: theme.spacing(1),
        transform: `translate(${theme.spacing(4)}, ${theme.spacing(
          0,
        )}) scale(0.75)`,
        color: !error && theme.palette.primary.main,
      },
      '.MuiFormHelperText-root': {
        color: theme.palette.primary.main,
      },
    },
    '.Mui-error': {
      label: {
        color: theme.palette.error.main,
      },
      input: {
        borderColor: theme.palette.error.main,
      },
      '&.MuiFormHelperText-root': {
        color: theme.palette.error.main,
      },
    },
    '.Mui-disabled': {
      '&.MuiFormLabel-root': {
        color: theme.palette.grey[200],
      },
      '&.MuiFormHelperText-root': {
        color: alpha(theme.palette.common.black, 0.38),
      },
    },
  }),
);
